<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Vevőcsoportok</span>
      <el-button
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        @click="$router.replace('/data/customer-groups/add')"
        icon="el-icon-plus"
        v-can="'customergroup.create'"
      >
        Új vevőcsoport
      </el-button>
    </div>
    <table-filter :config="filterConfig" action="customerGroup/fetchAll" />
    <customer-group-list />
    <template v-if="$route.meta.showAddCustomerGroupDialog">
      <customer-group-dialog
        type="add"
      />
    </template>
    <template v-if="$route.meta.showUpdateCustomerGroupDialog">
      <customer-group-dialog
        :customerGroupId="$route.params.id"
        type="update"
      />
    </template>
  </el-card>
</template>

<script>
import CustomerGroupList from '../../components/data/customerGroups/List';
import CustomerGroupDialog from '../../components/data/customerGroups/Dialog';
import TableFilter from '../../components/TableFilter';

export default {
  components: {
    CustomerGroupList,
    CustomerGroupDialog,
    TableFilter,
  },
  data() {
    return {
      filterConfig: [
        {
          type: 'text',
          name: 'name',
          label: 'Név',
          defaultSearch: true,
        },
      ],
    };
  },
};
</script>
